import { render } from "./index.vue?vue&type=template&id=310a6c89&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./index.vue?vue&type=style&index=1&id=310a6c89&lang=scss&scoped=true"

import exportComponent from "/Users/kgeek/KGEEK/PERSONNAL/REMA/traning_lists/scm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310a6c89"]])

export default __exports__